import {
    Col,
    Row,
} from 'reactstrap';

import CarrierInformation from './CarrierInformation';
import CheckListsCard from './CheckListsCard';
import DocumentEvidence from './DocumentEvidence';
import RequestInformation from './RequestInformation';

const Summary = ({
    bid,
}) => {
    return (
        <Row>
            <Col xl="7">
                <CheckListsCard bid={bid} />
            </Col>

            <Col xl="5">
                {bid.showRequestInformation && (
                    <RequestInformation />
                )}
                <CarrierInformation company={bid.company} />
                <DocumentEvidence
                    addDocumentLabel={bid.addDocumentLabel}
                    documents={bid.documents}
                    showAddDocument={bid.showAddDocument}
                />
            </Col>
        </Row>
    );
};

export default Summary;
